import { ReactNode } from 'react';
import { Box, Container } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import Navbar from './Navbar';
import Footer from './Footer';
import ParticleBackground from '../animations/ParticleBackground';
import ScrollToTop from '../ui/ScrollToTop';

type LayoutProps = {
  children: ReactNode;
};

// Page transition variants
const pageVariants = {
  initial: {
    opacity: 0,
    y: 20,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4,
      ease: 'easeInOut',
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
      ease: 'easeInOut',
    },
  },
};

const Layout = ({ children }: LayoutProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        position: 'relative',
      }}
    >
      {/* Global particle background */}
      <ParticleBackground />
      
      {/* Navbar with increased z-index */}
      <Box sx={{ position: 'relative', zIndex: 10 }}>
        <Navbar />
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          paddingTop: { xs: 4, md: 0 },
          paddingBottom: { xs: 4, md: 6 },
          position: 'relative',
          zIndex: 5,
        }}
      >
        <Container maxWidth="lg">
          <AnimatePresence mode="wait">
            <motion.div
              initial="initial"
              animate="animate"
              exit="exit"
              variants={pageVariants}
              style={{ width: '100%' }}
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </Container>
      </Box>

      {/* Footer */}
      <Footer />
      
      {/* Scroll to top button */}
      <ScrollToTop />
    </Box>
  );
};

export default Layout;
